// 全局常量
export const apiHost = process.env.NODE_ENV ===
'production' ? 'http://admin.hrzan.com/j/crm' : 'http://admin.hrzan.com/j/crm';
export const ossHost = process.env.NODE_ENV === 'production' ? 'https://dlhr.oss-cn-hangzhou.aliyuncs.com'
 : 'https://dlhr-test.oss-cn-hangzhou.aliyuncs.com';
export const platform = 'wechat';
export const version = '1.6.0';
// cookie uid key
export const uidKey = process.env.NODE_ENV === 'production' ? 'uid' : 'UID-TEST';
// cookie token key
export const tokenKey = process.env.NODE_ENV === 'production' ? 'token' : 'TOKEN-TEST';
// cookie user key
export const userKey = 'user';
export const nApiPrefix = '/n';
export const j2ApiPrefix = '/j2';
export const tApiPrefix = '/tk';
// 红点点对接推广链接
// eslint-disable-next-line
export const hddShareUrl = 'http://h5.hrdd.hongrendd.com/enterpriseZone/taskPeople_SDK.html?type=0&yqaccountId=11677211&yqcode=2543362';
// 跳转到app-web项目的前缀
export const appwebHref = process.env.NODE_ENV === 'production' ?
 'https://m.zanhr.com/m' : 'http://task.test.hrzan.com/m';



// WEBPACK FOOTER //
// ./src/config/index.js